<template>
  <div>
    <a-form :form="form" style="max-width: 500px; margin: 40px auto 0;">
      <a-form-item label="账号名" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }">
        <a-input type="text" autocomplete="false" :value="accountName" disabled></a-input>
      </a-form-item>
      <a-popover placement="rightTop" trigger="click" :visible="passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['user-register', passwordLevelClass]">
              强度：
              <span>{{ passwordLevelName }}</span>
            </div>
            <a-progress :percent="percent" :showInfo="false" :strokeColor="passwordLevelColor" />
            <div style="margin-top: 10px;">
              <span>请至少输入 6-20 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-item label="新密码" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" class="stepFormText">
          <a-input-password v-model="passwordF" v-decorator="['password', validatorRules.password]" type="password"
            autocomplete="false" @input="handleInput" @blur="handleBlur"></a-input-password>
        </a-form-item>
      </a-popover>
      <a-form-item label="确认密码" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" class="stepFormText">
        <a-input-password v-decorator="['confirmPassword', validatorRules.confirmpassword]" type="password"
          autocomplete="false"></a-input-password>
      </a-form-item>
      <a-form-item :wrapperCol="{ span: 19, offset: 5 }">
        <a-button style="margin-left: 8px" @click="prevStep">上一步</a-button>
        <a-button :loading="loading" type="primary" @click="nextStep" style="margin-left:20px">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { putAction, getAction } from '@/api/manage'
const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
export default {
  name: 'Step3',
  //    components: {
  //      Result
  //    },
  props: ['userList'],
  data() {
    return {
      passwordF: '',
      percent: 10,
      passwordLevel: 0,
      loading: false,
      form: this.$form.createForm(this),
      accountName: this.userList.username,
      validatorRules: {
        oldpassword: {
          rules: [
            {
              required: true,
              message: '请输入旧密码!'
            }
          ]
        },
        password: {
          rules: [
            {
              required: true,
              pattern: /^[A-Za-z0-9_]{6,20}$/,
              message: '密码由6-20位数字、大小写字母组成!'
            },
            {
              validator: this.validateToNextPassword
            }
          ]
        },
        confirmpassword: {
          rules: [
            {
              required: true,
              message: '请确认新密码!'
            },
            {
              validator: this.compareToFirstPassword
            }
          ]
        }
      },
      passwordLevelChecked: false
    }
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.passwordLevel]
    },
    passwordLevelName() {
      return levelNames[this.passwordLevel]
    },
    passwordLevelColor() {
      return levelColor[this.passwordLevel]
    }
  },
  methods: {
    handleInput() {
      this.passwordLevelChecked = true
      this.handlePasswordLevel(this.passwordF)
    },
    handleBlur() {
      this.passwordLevelChecked = false
    },
    nextStep() {
      let that = this
      that.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          var params = {}
          params.username = this.userList.username
          params.password = values.password
          params.smscode = this.userList.smscode
          params.phone = this.userList.phone
          getAction('/sys/user/passwordChange', params).then(res => {
            if (res.success) {
              var userList = {
                username: this.userList.username
              }
              console.log(userList)
              setTimeout(function () {
                that.$emit('nextStep', userList)
              }, 1500)
            } else {
              this.passwordFailed(res.message)
              that.loading = false
            }
          })
        } else {
          that.loading = false
        }
      })
    },
    prevStep() {
      this.$emit('prevStep', this.userList)
    },
    handlePasswordLevel(value) {
      let level = 0
      // let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/
      // let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
      let reg = /^[A-Za-z0-9_]{6,20}$/
      // let reg = /^[0-9]{8,20}$/
      if (!reg.test(value)) {
        console.log(value)
        // callback(new Error('密码由6-20位数字、大小写字母组成!'))
      }
      // 判断这个字符串中有没有数字
      if (/[A-Za-z0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (
        ((/[a-z]/.test(value) && /[0-9]/.test(value)) ||
          (/[A-Z]/.test(value) && /[0-9]/.test(value)) ||
          (/[A-Z]/.test(value) && /[a-z]/.test(value))) &&
        value.length > 1
      ) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[a-z]/.test(value) && value.length > 2 && /[A-Z]/.test(value) && /[0-9]/.test(value)) {
        level++
      }
      this.passwordLevel = level
      this.percent = level * 30
      if (level >= 2) {
        this.percent = level * 30
        if (level >= 3) {
          this.percent = 100
        }
        // callback()
      } else {
        if (level === 0) {
          this.percent = 10
        }
        // callback(new Error('密码强度不够'))
      }
      // callback()
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样！')
      } else {
        callback()
      }
    },
    passwordFailed(err) {
      this.$notification['error']({
        message: '更改密码失败',
        description: err,
        duration: 4
      })
    }
  }
}
</script>
<style lang="less" scoped>
.stepFormText {
  margin-bottom: 24px;
}

.ant-form-item-label,
.ant-form-item-control {
  line-height: 22px;
}
</style>